import { useState, useEffect } from 'react';
import { db } from '../firebase';
import { collection, getDocs } from 'firebase/firestore';

// Fallbacks por si Firestore está vacío o hay error de red
const FALLBACK = {
  sectores:          ['Comercial','Corporativo','Hostelería','Otro','Residencial','Sanitario'],
  fuentes:           ['Boca-oreja','Conocido / Cercanía','Instagram','Otro','Web'],
  tipos_proyecto:    ['Otro','Proyecto y Dirección','Restyling','Solo Proyecto'],
  categorias_horas:  ['Administración/Gestión','Comercial','Formación','Otro eIC','Otro eINES','Reuniones internas','RRSS Instagram','RRSS Youtube'],
};

async function cargarLista(nombre) {
  const snap = await getDocs(collection(db, 'config', 'listas', nombre));
  if (snap.empty) return FALLBACK[nombre] || [];
  const items = snap.docs.map(d => d.data().valor);
  return items.sort((a, b) => a.localeCompare(b, 'es', { sensitivity: 'base' }));
}

/**
 * Hook reutilizable. Uso:
 *   const { sectores, fuentes, tiposProyecto } = useListasConfig();
 *
 * Pedir solo las que necesitas:
 *   const { sectores } = useListasConfig(['sectores']);
 */
export function useListasConfig(listas = ['sectores', 'fuentes', 'tipos_proyecto']) {
  const [sectores,        setSectores]        = useState(FALLBACK.sectores);
  const [fuentes,         setFuentes]         = useState(FALLBACK.fuentes);
  const [tiposProyecto,   setTiposProyecto]   = useState(FALLBACK.tipos_proyecto);
  const [categoriasHoras, setCategoriasHoras] = useState(FALLBACK.categorias_horas);

  useEffect(() => {
    if (listas.includes('sectores'))
      cargarLista('sectores').then(setSectores).catch(() => {});
    if (listas.includes('fuentes'))
      cargarLista('fuentes').then(setFuentes).catch(() => {});
    if (listas.includes('tipos_proyecto'))
      cargarLista('tipos_proyecto').then(setTiposProyecto).catch(() => {});
    if (listas.includes('categorias_horas'))
      cargarLista('categorias_horas').then(setCategoriasHoras).catch(() => {});
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { sectores, fuentes, tiposProyecto, categoriasHoras };
}
